import { Box, Typography } from "@mui/material";
import { Fragment, useCallback } from "react";

type BaseNavigationProps = {
  currentStep: number;
  stepperList: string[];
};

export const BaseStepper = ({
  currentStep,
  stepperList,
}: BaseNavigationProps) => {
  const stepperCount = stepperList.length;

  const isDone = useCallback(
    (index: number) => {
      return index < currentStep;
    },
    [currentStep],
  );

  const isReady = useCallback(
    (index: number) => {
      return index <= currentStep;
    },
    [currentStep],
  );

  const isDoing = useCallback(
    (index: number) => {
      return index === currentStep;
    },
    [currentStep],
  );

  const navBgColor = useCallback((isDone: boolean) => {
    return isDone ? "primary.400" : "grey.50";
  }, []);
  const textColor = useCallback((isDone: boolean) => {
    return isDone ? "white" : "grey.300";
  }, []);

  const NavDivider = useCallback(
    ({ isDone, isDoing }: { isDone: boolean; isDoing: boolean }) => (
      <svg
        role="img"
        aria-label="Divider"
        width="14"
        height="72"
        viewBox="0 0 14 72"
        fill={isDone || isDoing ? "#52A48B" : "transparent"}
        xmlns="http://www.w3.org/2000/svg"
        style={{
          backgroundColor: isDone ? "#52A48B" : "none",
          marginLeft: "-1px",
        }}
      >
        <path
          d="M0.666504 0L12.6665 36L0.666504 78"
          stroke={isDoing ? "#52A48B" : "#E4E5E5"}
        />
      </svg>
    ),
    [],
  );

  return (
    <Box
      display="flex"
      bgcolor="grey.50"
      color="grey.300"
      maxWidth="628px"
      height={{ xs: "64px", sm: "72px" }}
      borderRadius="36px"
      boxShadow="0px 1px 10px 0px #0000001A"
      overflow="hidden"
    >
      {stepperList.map((nav, index) => (
        <Fragment key={`${nav}`}>
          <Box
            display="flex"
            justifyContent="center"
            width={`calc(100%/${stepperCount})`}
            bgcolor={navBgColor(isReady(index))}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                textAlign="center"
                fontSize={{ xs: "20px", sm: "24px" }}
                fontWeight="700"
                lineHeight={1}
                color={textColor(isReady(index))}
              >
                {index + 1}
              </Typography>
              <Typography
                fontSize={{ xs: "14px", sm: "20px" }}
                fontWeight="700"
                color={textColor(isReady(index))}
              >
                {nav}
              </Typography>
            </Box>
          </Box>
          {index < stepperCount - 1 && (
            <NavDivider isDone={isDone(index)} isDoing={isDoing(index)} />
          )}
        </Fragment>
      ))}
    </Box>
  );
};
